import { Log, LogCategory } from '@augloop/logging';
import { WebSocketWorker, TokenCache } from '@augloop/runtime-client';
import { ExceptionType } from '@augloop/schemas';
import { WebSocketRequestManager } from './websocket/websocket-request-manager';
var requestTimeoutInMs = 30000;
var maxActiveRequests = 50;
var tokenCache;
export var clearTokenCache = function () {
    tokenCache = new TokenCache();
};
clearTokenCache();
var webSocketRequestManager = new WebSocketRequestManager(requestTimeoutInMs, function () { return new WebSocketWorker(); }, maxActiveRequests);
var executeRemoteLambdaWithRetries = function (url, message, inputSchema, outputSchema, correlationId, clientMetadata, hostCallbacks, retries, context, done) {
    var data = {
        payload: message.payload,
        payloadSchema: inputSchema,
        requestedSchema: outputSchema,
        clientMetadata: clientMetadata,
        tokens: tokenCache.getAuthTokenEntries(hostCallbacks, context.docId)
    };
    var schemaName = '';
    if (outputSchema && outputSchema.schema) {
        schemaName = outputSchema.schema.name;
    }
    var responseReceived = false;
    webSocketRequestManager.addRequest(url, data, correlationId, schemaName, function (data, error, _end) {
        if (!responseReceived) {
            responseReceived = true;
            if (error != null) {
                if (error.exceptionType === ExceptionType.Authentication) {
                    try {
                        var ticket = JSON.parse(error.data);
                        if (retries > 0) {
                            Log.info(0x2224d0dc /* tag_8jnd2 */, LogCategory.CoreDefault, 'Auth token required for remote lambda WebSocket request');
                            tokenCache
                                .updateAuthToken(hostCallbacks, { Tickets: [ticket], DocId: context.docId })
                                .then(function () {
                                executeRemoteLambdaWithRetries(url, message, inputSchema, outputSchema, correlationId, clientMetadata, hostCallbacks, retries - 1, context, done);
                            })
                                .catch(function (err) {
                                // Missing or invalid ticket or token
                                done({
                                    exceptionType: ExceptionType.Authentication,
                                    message: err.message
                                });
                            });
                        }
                        else {
                            done({
                                exceptionType: ExceptionType.Authentication,
                                message: 'Remote lambda request retry with authentication token failed'
                            });
                        }
                    }
                    catch (e) {
                        // Missing or invalid ticket
                        done({
                            exceptionType: ExceptionType.Authentication,
                            message: e.message
                        });
                    }
                }
                else {
                    done(new Error("Error in remote lambda WebSocket request to ".concat(url, ": ").concat(error)));
                }
            }
            else {
                // We only support one result payload
                message.moreResults = false;
                done(null, data);
            }
        }
    });
};
export var executeRemoteLambda = function (url, message, inputSchema, outputSchema, correlationVector, clientMetadata, hostCallbacks, context, done) {
    if (Array.isArray(context.authTickets)) {
        tokenCache
            .updateAuthToken(hostCallbacks, {
            Tickets: context.authTickets,
            DocId: context.docId
        })
            .then(function () {
            executeRemoteLambdaWithRetries(url, message, inputSchema, outputSchema, correlationVector.id, clientMetadata, hostCallbacks, 1, context, done);
        })
            .catch(function (err) {
            // Missing or invalid ticket or token
            done({
                exceptionType: ExceptionType.Authentication,
                message: err.message
            });
        });
    }
    else {
        executeRemoteLambdaWithRetries(url, message, inputSchema, outputSchema, correlationVector.id, clientMetadata, hostCallbacks, 1, context, done);
    }
};
export var testWebSocketConnection = function (url, clientMetadata) {
    return webSocketRequestManager.testConnection(url, clientMetadata);
};
//# sourceMappingURL=remote-lambda-ws.js.map